import {createSelector} from 'reselect'
import {AppState} from 'redux/config'
import defaultAuthState from './state'

export const select_auth = (state: AppState) => state.auth

export const select_auth_isAuthenticated = createSelector(
  select_auth,
  auth => auth?.isAuthenticated ?? defaultAuthState.isAuthenticated
)

export const select_auth_user = createSelector(
  select_auth,
  auth => auth.user
)

export const select_user_VM = createSelector(
  select_auth_user,
  user => {
    let role = ''
    if (user.isAdmin) role = ', Admin'
    if (user.isPowerUser && !user.isAdmin) role = ', Power User'

    return {
      ...user,
      role,
    }
  }
)
